/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import { memo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '..';

interface Props {
  /**
   * Insurance codes that are in the spreadsheet, but have not been added in the backend.
   */
  readonly newCodes: Readonly<Record<string, true>>;
}

const NewCodes = ({ newCodes }: Props) => (
  <table
    css={css`
      border-collapse: separate;
      border-spacing: 0;
      height: 100%;
      width: 100%;
    `}
  >
    <tbody>
      <td
        css={css`
          height: 100%;
          vertical-align: top;
        `}
      >
        <TableContainer
          css={css`
            height: 100%;
            max-height: 100%;
          `}
        >
          <Table size='small' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Insurance Code</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(newCodes).map((code) => (
                <TableRow key={code}>
                  <TableCell>{code}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </td>
    </tbody>
  </table>
);

export default memo(NewCodes);
